module.exports = __webpack_public_path__ + "img/noGuide_b.41a03564.svg";